import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../../hooks/hooks";
import PageLoader from "../../../../components/PageLoader";
import { selectglobalParsingRulesListItems } from "../../../../redux/global-parsing-rules/selector";
import { globalParsingRules } from "../../../../redux/global-parsing-rules/action";
import Table from "../../../../common/components/table-manager/v1.1/table";
import { tenantFunctions } from "../../../../redux/tenant-functions/action";
import { selectTenantFunctionsListItems } from "../../../../redux/tenant-functions/selector";

const GlobalParsingRules = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const [pageData, setPageData] = useState(1)
  const [pageSize, setPageSize] = useState(10);
  const [filterCriteriaList, setFilterCriteriaList] = useState<any>([]);
  const [searchCriteriaList, setSearchCriteriaList] = useState<any>([]);
  const [dateCriteriaList, setDateCriteriaList] = useState<any>([]);
  const tenantfunctionsLists = useSelector(selectTenantFunctionsListItems)
  const globalParsingRulesListData = useSelector(selectglobalParsingRulesListItems)
  const [
    columnDefs,
    setColumnDefs
  ] = useState({});
  const createColumnDefs: any = () => {
    setColumnDefs([
      {
        field: 'Sl',
        sortable: false,
        filter: false,
        isSortLabel: true,
        headerName: 'Sl',
        cellRenderer(params: any) {
          return parseInt(
            params.node.id,
            10
          ) + 1;
        },
      },
      { field: 'Name', headerName: 'Name', searchField: 'Name', sortable: true, filter: true, filterType: 'text',  },
      { field: 'OwnerType', headerName: 'Owner Type', searchField: 'OwnerType', sortable: true, filter: true, filterType: 'text',  },
      { field: 'CreatedOnUtc', headerName: 'Created On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date', },
      { field: 'ModifiedOnUtc', headerName: 'Modified On', isDateValueFormat: true, sortable: true, filter: true, filterType: 'date', },

    ]);
  }

  const listTenantDomainFunctions = () => {
    dispatch(tenantFunctions.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/platform-management/functions/list`, entity: 'tenantFunctions', jsonData: {
              // Filters: [
              //   {
              //     FieldName: 'IsTemplateMappingEnabled',
              //     FieldText: 'TemplateMappingEnabled',
              //     FieldType: 'boolean',
              //     FilterOperatorId: 1,
              //     FieldValue: true
              //   }
              // ]
            }
          }))
  }


  const fetchParsingRules = async () => {
    await dispatch(globalParsingRules.list({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-parsing-rules/fetch`, entity: 'globalParsingRules', jsonData: 
      {
        "Context": {
          
        },
        "Records": [
          {}
        ],
        "Pagination": {
          "PageNumber": pageData,
          "PageSize": pageSize,
          "SortField": "string",
          "SortOrder": "string",
          "isOrCondition": true,
          "isFilterConditionOr": true,
          "isSearchConditionOr": true,
          "Filters": filterCriteriaList,
          "Searches": searchCriteriaList,
          "DateCriteria": dateCriteriaList
        }
      }
    }))
  }

  const handleSearch = (data: any) => {
    console.log('Search data', data)
    let searchCriteria = {};
    if (data?.column) {
      searchCriteria = [{
        FieldName: data?.column,
        FieldText: data?.column,
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    } else {
      searchCriteria = [{
        FieldName: "Name",
        FieldText: "Name",
        FieldType: 'text',
        FilterOperatorId: 6,
        FieldValue: data?.value
      }]
    }

    setSearchCriteriaList(searchCriteria)
  }

  const handleReloadData = () => {
    fetchParsingRules();
  }
    
  const additionButtons: any = [
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 24 24" width="24" height="24" className="mr-2">
          <title>Add Global Parsing Rule</title>
          <path d="M12 5v14m-7-7h14" stroke="currentColor" stroke-width="2" fill="none" />
        </svg>,
      // name: 'Domain',
      callback: () => handleAdd(),
    },
    {
      svg:
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" width="24" height="24">
          <title>Reload</title>
          <path d="M20.0092 2V5.13219C20.0092 5.42605 19.6418 5.55908 19.4537 5.33333C17.6226 3.2875 14.9617 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>,
      // name: 'Reload',
      callback: () => handleReloadData(),
    },
  ];
 
  const handleDelete = (data: any) => {
    dispatch(globalParsingRules.delete({
      url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/service/global-parsing-rules/delete`,
      entity: 'globalParsingRules',
      jsonData: {
        Context: {},
        Records: [
          {
            Id: data?.GlobalParsingRuleId
          }
        ]
      }
    })).then(() => {
      fetchParsingRules();
    });
  }
  const handleEdit = (data: any) => {
    navigate(`${data?.GlobalParsingRuleId}`)
  }

  const handleAdd = () => {
    navigate(`${0}`)
  }

  useEffect(() => {
    createColumnDefs()
    if (!tenantfunctionsLists?.result?.items?.length) {
      listTenantDomainFunctions();
    }
  }, [])


  useEffect(() => {
    fetchParsingRules()
  }, [pageData, pageSize, searchCriteriaList, filterCriteriaList, dateCriteriaList])


  return (
    <>
      {globalParsingRulesListData?.isLoading || tenantfunctionsLists?.isLoading?
        <PageLoader />
        :
        <Table
          columnData={columnDefs}
          rowData={globalParsingRulesListData?.result?.items}
          enableFilter={true}
          setPageData={setPageData}
          setPageSize={setPageSize}
          paginationData={globalParsingRulesListData?.result?.pagination}
          onSearch={handleSearch}
          searchCriteriaList={searchCriteriaList}
          onEdit={handleEdit}
          onDelete={handleDelete}
          additionButtons={additionButtons}
          checkboxConfig={{
            allowMultiSelect: true,
            defaultSelectedIds: [],
            isDisabled: false,
            keyColumn: 'Name',
          }}
          headingName="Global Parsing Rules"
        />
      }
    </>



  );
};

export default GlobalParsingRules;


